export default defineNuxtRouteMiddleware((to) => {
    const store = useDefaultStore();

    if (to.path.startsWith("/calendar") && !store.hasAccess("view_calendar")) {
        return navigateTo("/");
    }
    if (to.path.startsWith("/kitchen") && !store.hasAccess("view_kitchen")) {
        return navigateTo("/");
    }
    if (
        to.path.startsWith("/delivery") &&
        !store.hasAccess("view_routeplanning")
    ) {
        return navigateTo("/");
    }
    if (
        to.path.startsWith("/routeplanning") &&
        !store.hasAccess("edit_routeplanning")
    ) {
        return navigateTo("/");
    }

    const { today, tomorrow, thisWeek, thisMonth } = useDateCalculations();

    const to_path = to.path.replace(/\/$/, "");

    if (to_path === "/calendar") {
        return navigateTo(`/calendar/${thisMonth}`);
    }
    if (to_path === "/kitchen" || to_path === "/kitchen/day") {
        return navigateTo(`/kitchen/day/${today}`);
    }
    if (to_path === "/delivery" || to_path === "/delivery/today") {
        return navigateTo(`/delivery/${today}`);
    }
    if (to_path === "/routeplanning" || to_path === "/routeplanning/tomorrow") {
        return navigateTo(`/routeplanning/${tomorrow}`);
    }
    if (to_path === "/kitchen/week") {
        return navigateTo(`/kitchen/week/${thisWeek}`);
    }
    if (to_path === "/kitchen/month") {
        return navigateTo(`/kitchen/month/${thisMonth}`);
    }
});
